export class Asset {
  public id: string = '';
  public type: string = '';
  public assetKey: string = '';
  public accessLevel: string = '';
  public assetValue: string = '';
}

export const AssetTypes = {
  ASSET_TYPE_IMAGE: {
    key: "asset.type.image",
    name : 'Bild',
  },
  ASSET_TYPE_TEXT: {
    key: "asset.type.text",
    name : 'Text',
  },
};
